import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import SalesInvoiceRegisterForm from '../components/SalesInvoiceRegisterForm';
import { useCreateSalesInvoiceRegisterHandler } from '../dataHandlers/createSalesInvoiceRegisterHandler';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { usePermissions } from '../../../hooks/usePermissions';
import { CREATE_SALE_REGISTER } from '../../../constants/eInvoicePermissions';
import { useActionDeniedSnackbar } from '../../../hooks/useActionDeniedSnackbar';

export default function CreateSalesInvoiceRegisterPage() {
  const { salesInvoiceRegister, eInvoiceForm } = useTranslatedMessages();
  useDocumentTitle(salesInvoiceRegister?.pages?.create_title ?? 'Create Sales Invoice Register Entry');
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { loading, hasEInvoicePermission } = usePermissions();
  const showActionDeniedSnackbar = useActionDeniedSnackbar();

  useEffect(() => {
    if (loading) return;
    if (!hasEInvoicePermission(CREATE_SALE_REGISTER)) {
      showActionDeniedSnackbar();
      navigate('/sales-invoice-register', { replace: true });
    }
  }, [loading, hasEInvoicePermission, showActionDeniedSnackbar, navigate]);

  const onRegisterCreated = (data) => {
    const documentId = data?.uuid || data?.id;
    navigate('/sales-invoice-register');
  };

  const { onSubmit, error, isPending } = useCreateSalesInvoiceRegisterHandler({ onSuccess: onRegisterCreated });

  useEffect(() => {
    if (!isPending && isSubmitting) {
      setIsSubmitting(false);
    }
  }, [isPending, isSubmitting]);

  const onSaveForm = (data) => {
    setIsSubmitting(true);
    onSubmit(data);
  };

  const onCancel = () => {
    navigate('/sales-invoice-register', { replace: true });
  };

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <SalesInvoiceRegisterForm
        initialData={{}}
        onSubmit={onSaveForm}
        onCancel={onCancel}
        apiErrors={error}
        isLoading={isPending || isSubmitting}
      />
    </Stack>
  );
}
